"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (a, b) {
    var aH = +a.slice(0, 2);
    var aM = +a.slice(3, 5);
    var aS = +a.slice(6);

    var bH = +b.slice(0, 2);
    var bM = +b.slice(3, 5);
    var bS = +b.slice(6);

    if (aH !== bH) {
        return aH > bH;
    } else if (aM !== bM) {
        return aM > bM;
    }
    return aS > bS;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/date/timeStringBigger.js
// module id = 287
// module chunks = 0